export const linkAthleteLogin = "https://help.outputsports.com/en/articles/10553116-athlete-level-login";
export const linkGroups = "https://help.outputsports.com/en/articles/10553113-groups";
export const linkLeaderboards = "https://help.outputsports.com/en/articles/10553084-how-to-create-leaderboards-on-hub";
export const linkWorkouts = "https://help.outputsports.com/en/articles/10553099-workouts";
export const linkExportData = "https://help.outputsports.com/en/articles/10553079-how-to-export-data-from-the-hub";
export const linkChooseBaseExercise =
  "https://help.outputsports.com/en/articles/11132238-how-to-choose-a-base-exercise-when-creating-a-custom-exercise";
export const hyroxEliteDemoUrl =
  "https://help.outputsports.com/en/articles/14109270-hyrox-x-output-sports-tier-overview";
export const linkVelocityBasedOneRepMax =
  "https://help.outputsports.com/en/articles/12098600-monitoring-updating-1rm-in-output";
